module.exports = "/assets/images/minus_bbd49c.svg";